export const dashboardPagesMenu = {
	// Menu Leads
	dashboard: {
		id: 'dashboard',
		text: 'Crea lead',
		path: 'lead/',
		icon: 'People',
		category: 'leads',
	},
	anagrafica: {
		id: 'anagrafica',
		text: 'Cerca leads',
		path: 'leads-table/',
		icon: 'PersonSearch',
		category: 'leads',
	},

	// Menu Templates
	template: {
		id: 'template',
		text: 'Crea template',
		path: 'template/',
		icon: 'IntegrationInstructions',
		hide: true,
		category: 'template',
	},
	updateTemplate: {
		id: 'updateTemplate',
		text: 'Modifica template',
		path: 'update-template/',
		icon: 'Update',
		hide: true,
		category: 'template',
	},

	// Menu Gestione
	agency: {
		id: 'agency',
		text: 'Agenzie',
		path: 'create-agency/',
		icon: 'AddBusiness',
		category: 'management',
	},
	operators: {
		id: 'operators',
		text: 'Operatori',
		path: 'operators',
		icon: 'SupportAgent',
		hide: true,
		category: 'management',
	},
	groups: {
		id: 'groups',
		text: 'Gruppi',
		path: 'groups',
		icon: 'LocalOffer',
		hide: true,
		category: 'management',
	},

	// Menu Statistiche e Reportistica
	stats: {
		id: 'stats',
		text: 'Statistiche',
		path: 'stats',
		icon: 'Insights',
		category: 'reports',
	},
	esiti: {
		id: 'Esiti',
		text: 'Esiti',
		path: 'esiti',
		icon: 'AddTask',
		adminHide: true,
		category: 'reports',
	},

	// Menu Comunicazioni
	templateSms: {
		id: 'templateSms',
		text: 'Template SMS',
		path: 'template-sms',
		icon: 'Sms',
		adminHide: true,
		category: 'comunicazioni',
	},
	sendMassiveSms: {
		id: 'sendMassiveSms',
		text: 'Invia SMS',
		path: 'massive-sms',
		icon: 'Send',
		adminHide: true,
		category: 'comunicazioni',
	},
	emailConfig: {
		id: 'emailConfig',
		text: 'Configurazione Email',
		path: 'email-config',
		icon: 'Settings',
		category: 'comunicazioni',
	},
	templateEmail: {
		id: 'templateEmail',
		text: 'Template Email',
		path: 'template-email',
		icon: 'Email',
		category: 'comunicazioni',
	},
	sendMassiveEmail: {
		id: 'sendMassiveEmail',
		text: 'Invia Email',
		path: 'massive-email',
		icon: 'Send',
		category: 'comunicazioni',
	},
	emailHistory: {
		id: 'emailHistory',
		text: 'Storico Email',
		path: 'email-history',
		icon: 'History',
		category: 'comunicazioni',
	},

	// Menu Configurazione
	subscriptions: {
		id: 'subscriptions',
		text: 'Abbonamenti',
		path: 'subscriptions',
		icon: 'Subscriptions',
		hide: true,
		category: 'impostazioni',
	},
	regole: {
		id: 'rules',
		text: 'Regole',
		path: 'settings-agency',
		icon: 'AdminPanelSettings',
		adminHide: true,
		category: 'impostazioni',
	},
	settings: {
		id: 'settings',
		text: 'Impostazioni',
		path: 'my-settings',
		icon: 'Settings',
		category: 'impostazioni',
	},
	channels: {
		id: 'channels',
		text: 'Gestione Canali',
		path: 'channel-management',
		icon: 'SettingsInputComponent',
		category: 'management',
	},

	// Listini (aggiunto)
	listini: {
		id: 'listini',
		text: 'Listini',
		path: 'listini',
		icon: 'ReceiptLong',
		adminHide: true,
		category: 'management',
	},
};

// -----------------------------
// MENU AGENCY
// -----------------------------
export const agencyPagesMenu = {
	agency: {
		id: 'home',
		text: 'Homepage',
		path: 'home-agency',
		icon: 'Home',
	},
};

// -----------------------------
// MENU APPUNTAMENTI
// -----------------------------
export const agencyPagesAppointment = {
	appointment: {
		id: 'appuntamenti',
		text: 'Appuntamenti',
		path: 'appointment-agency',
		icon: 'Event',
	},
};

// -----------------------------
// MENU NOTIFICHE E MESSAGGI
// -----------------------------
export const messageUnreadPages = {
	message: {
		id: 'notification',
		text: 'Messaggi non letti',
		path: 'notification',
		icon: 'Notifications',
	},
};

// -----------------------------
// MENU RICHIESTA LEAD
// -----------------------------
export const requestLeadPage = {
	requestLead: {
		id: 'requestLead',
		text: 'Richiedi nuovi lead',
		path: 'request-lead',
		icon: 'Add',
	},
};

// -----------------------------
// MENU LOGIN
// -----------------------------
export const loginPagesMenu = {
	login: {
		id: 'login',
		text: 'Login',
		path: 'login',
		icon: 'Login',
	},
};

// -----------------------------
// MENU HOME PAGE
// -----------------------------
export const homePage = {
	login: {
		id: 'homepage',
		text: 'Homepage',
		path: 'homepage',
		icon: 'Home',
	},
};

// -----------------------------
// MENU PAGINE ERRORE
// -----------------------------
export const unloggedPages = {
	page404: {
		id: 'Page404',
		text: '404 Page',
		path: '404',
		icon: 'ReportGmailerrorred',
	},
};

// -----------------------------
// MENU PAGAMENTI
// -----------------------------
export const stripePages = {
	paymentSuccess: {
		id: 'Pagamento effettuato',
		text: 'Pagamento effettuato',
		path: 'payment-success',
		icon: 'CheckCircle',
	},
	paymentCharge: {
		id: 'Pagamento',
		text: 'Pagamento',
		path: 'payment',
		icon: 'Payment',
	},
};

// -----------------------------
// MENU PROGRESS/REPORTISTICA
// -----------------------------
export const progressOperator = {
	progress: {
		id: 'report',
		text: 'Report',
		path: 'report',
		icon: 'Assessment',
	},
};

export const progressAgency = {
	progress: {
		id: 'report',
		text: 'Report agenzia',
		path: 'report-agency',
		icon: 'Assessment',
	},
};

// -----------------------------
// MENU SMS
// -----------------------------
export const agencyTemplateSms = {
	templateSms: {
		id: 'templateSms',
		text: 'Template SMS',
		path: 'template-sms',
		icon: 'Message',
	},
};

// -----------------------------
// MENU LISTINI (nuovo)
// -----------------------------
export const listiniPages = {
	listini: {
		id: 'listini',
		text: 'Listini',
		path: 'listini',
		icon: 'ReceiptLong',
	},
};
